import { render, staticRenderFns } from "./ActivityDetailsValidity.vue?vue&type=template&id=224d7599&"
import script from "./ActivityDetailsValidity.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailsValidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports